import { createModel } from "hox";
import React, { useEffect, useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage, OptionDsType } from "../../../types/FmsTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { beService, IMdBeDetail, IMdBeFields } from "./beService";
import { transPgToPagination } from "../app/appModel";
import { message } from "antd";

export enum BeOptModeEnum {
    ADD,
    EDIT,
    DETAIL
}

export const useBeModel = createModel(function () {
    const initSearchParam: IMdBeFields = {};
    const initDataSource: IMdBeDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //操作模式
    const [optMode, setOptMode] = useState<BeOptModeEnum>(BeOptModeEnum.ADD);
    //查询条件
    const [searchParam, setSearchParam] = useState<IMdBeFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdBeDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IMdBeDetail>();
    //开户银行类型
    const [accountBankTypeDs, setAccountBankType] = useState<OptionDsType[]>([]);

    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdBeFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IMdBeFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await beService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }

    const syncData = async () => {
        let ret = await beService.sync(searchParam);
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData();
        return ret.retData;
    }
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? filters[0] : null;
    };
    const disable = async () => {
        const selectedData = getSelectedRowData();
        if (selectedData) {
            let { retMsg, success } = await beService.disable({ code: selectedData?.code });
            if (success) {
                message.success('禁用成功！')
                await loadData()
            } else {
                message.error("禁用失败!" + retMsg)
            }
        }
    }
    const onSubmit = () => {
        console.log(optMode);
    }
    return {
        initSearchParam,
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        optMode,
        selectedData,
        accountBankTypeDs,
        /***method***/
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setDrawerVisible,
        setOptMode,
        setPgCfg,
        /***action***/
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        syncData,
        getSelectedRowData,
        onSubmit,
        disable,
        setSelectedData,
        setAccountBankType
    }
});
